const constants = {
    ACTIONS : {
    GET_PROFILE_DATA_SUCCESS : 'GET_PROFILE_DATA_SUCCESS',
    GET_PROFILE_DATA_FAILED : 'GET_PROFILE_DATA_FAILED',
    LOGOUT_SUCCESS:"LOGOUT_SUCCESS",
    }
}
export default constants;